<script setup lang="ts">
import { computed } from 'vue'
import { useTranslate } from '@tolgee/vue'

import { IMPACT_TYPES } from '@/api/interfaces'
import { useEditorStore } from '@/stores/Editor'
import { useAccountStore } from '@/stores/Account'

import FormGroup from '@/components/common/FormGroup.vue'
import ColorPicker from '@/components/common/ColorPicker.vue'

const editorStore = useEditorStore()
const accountStore = useAccountStore()
const { t } = useTranslate('local')

const disabled = computed(() => editorStore.publishLoading || accountStore.hasStarterPlan)
</script>

<template>
  <FormGroup
    v-for="impactType in IMPACT_TYPES"
    :key="impactType"
    class="editor-settings-impact-color-group"
    :class="{ disabled }"
    :label="t(`EditorImpactSettings.color.${impactType}`)"
    :label-for="`impact-${impactType}-color`"
    layout="cols"
  >
    <div class="editor-settings-impact-color-list">
      <ColorPicker
        v-model="editorStore.editor.icon.impactColors[impactType].backgroundColor"
        :label="t('EditorImpactSettings.color.backgroundColor')"
        :id="`impact-${impactType}-color`"
        :disabled="disabled"
      />
      <ColorPicker
        v-model="editorStore.editor.icon.impactColors[impactType].textColor"
        :label="t('EditorImpactSettings.color.textColor')"
        :disabled="disabled"
      />
    </div>
  </FormGroup>
</template>

<style lang="scss" scoped>
.editor-settings-impact-color-group {
  border-bottom: 1px solid var(--gray-light-cc);
  padding-bottom: 24px;
  margin-bottom: 24px;
  align-items: flex-start;

  &.disabled {
    color: var(--gray-light-a7);
  }
}

.editor-settings-impact-color-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @include media('md-and-up') {
    width: auto;
  }

  :deep(.color-picker) {
    @include media('md-and-up') {
      width: 200px;
    }
  }
}
</style>
